"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
var sns_button_list_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/sns_button_list"));
var mobx_1 = require("mobx");
var SnsButtonListStore = /** @class */ (function () {
    function SnsButtonListStore(props) {
        var _this = this;
        this.component = sns_button_list_1.default;
        this.formPath = '';
        this.googleOAuthPath = '';
        this.lineOAuthPath = '';
        this.updateOAuthPaths = function (query) {
            if (query === void 0) { query = {}; }
            var redirectPath = encodeURIComponent("".concat(_this.formPath, "?").concat(qs_1.default.stringify(query, { arrayFormat: 'brackets' })));
            _this.googleOAuthPath = "".concat(_this.googleOAuthPathBase, "?specified_redirect_url=").concat(redirectPath);
            _this.lineOAuthPath = "".concat(_this.lineOAuthPathBase, "?specified_redirect_url=").concat(redirectPath);
            if (typeof window !== 'undefined') {
                document.cookie = "redirect_path_after_login=".concat(redirectPath, "; path=/; max-age=600");
            }
        };
        this.enabled = props.enabled;
        this.authenticityToken = props.authenticityToken;
        this.googleOAuthPathBase = props.googleOAuthPathBase;
        this.lineOAuthPathBase = props.lineOAuthPathBase;
        this.handleClickButton = props.onClickButton;
        this.updateOAuthPaths();
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SnsButtonListStore.prototype, "formPath", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SnsButtonListStore.prototype, "googleOAuthPath", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SnsButtonListStore.prototype, "lineOAuthPath", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SnsButtonListStore.prototype, "updateOAuthPaths", void 0);
    return SnsButtonListStore;
}());
exports.default = SnsButtonListStore;
